import { CategoryProductsListSkeleton } from "@/components/e-commerce/category/products-list/skeleton"
import { CategorySidebarSkeleton } from "@/components/e-commerce/category/sidebar/skeleton"

export default function Loading(): React.ReactNode {
  return (
    <main aria-busy='true' aria-live='polite' className='mx-auto w-full p-6'>
      <div className='grid grid-cols-1 gap-6 lg:grid-cols-[18rem_minmax(0,1fr)]'>
        <CategorySidebarSkeleton />
        <CategoryProductsListSkeleton />
      </div>
    </main>
  )
}
